import { colours } from "./colours"

/**
 * These semantic shadow tokens represent various design system shadow groupings.
 * They should be used to maintain consistency between Design and Engineering.
 *
 * @constant
 * @property {Object} bottom - Bottom shadow variants
 * @property {string} bottom.l1 - Small bottom shadow
 * @property {string} bottom.l2 - Large bottom shadow
 *
 * @property {Object} top - Top shadow variants
 * @property {string} top.l1 - Small top shadow
 * @property {string} top.l2 - Large top shadow
 */
export const shadows = {
  bottom: {
    l1: `0px 2px 8px 0px ${colours.shadows.light}`,
    l2: `0px 4px 12px 2px ${colours.shadows.medium}`,
  },
  top: {
    l1: `0px -2px 8px 0px ${colours.shadows.light}`,
    l2: `0px -4px 12px 2px ${colours.shadows.medium}`,
  },
} as const
